import {
  Autocomplete,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  Paper,
  Select,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import MainCard from "../../../components/Maincard";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { useNavigate } from "react-router-dom";
import { SettingsOutlined, Today } from "@mui/icons-material";
import CustomPopup from "../../../components/CustomPopup";
import SpecificTaskPage from "../../../section/tasks/SpecificTaskPage";
import SpecificTaskTable from "./SpecificTaskTable";
import { useGetTokenOrLogout } from "../../../utils/token";
import CustomAutocompleteComp from "../../newComponent/AutocompleteComp";
import CustomTextFieldComp from "../../newComponent/customTextFieldComp";
import SearchButton from "../../newComponent/NewButtonComp/SearchButton";
import ResetButtonComp from "../../newComponent/NewButtonComp/ResetButtonComp";
import SearchTextFieldComp from "../../newComponent/newtextfieldComp/SearchTextFieldComp";
import CustomNoRowsOverlay from "../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import HeadingCard from "../../newComponent/NewCardsComp/HeadingCard";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function TaskReports() {
  const userId = localStorage.getItem("userId");
  const userRole = localStorage.getItem("userRole");
  const getTokenOrLogout = useGetTokenOrLogout();

  const [userlist, setUserlist] = useState([]);
  const [username, setUserName] = useState([]);
  const [filterType, setFilterType] = useState("today");
  const [isLoading, setIsLoading] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [todayTaskReportData, setTodayTaskReportData] = useState([]);
  const [taskReportData, setTaskReportData] = useState([]);
  const [namefilter, setNameFilter] = useState("");
  const [originalData, setOriginalData] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [selectedrowId, setSelectedRowId] = useState(null);
  const [filter, setFilter] = useState(null);
  const [filterData, setfilteredData] = useState([]);
  const [fetchedData, setFetchedData] = useState([]);
  const [gridKey, setGridKey] = useState(0);

  console.log("data1", selectedrowId, filter);

  const [taskloading, setTaskLoading] = useState(true);

  const handleOpenPopup = (id, filter) => {
    setOpenPopup(true);
    setSelectedRowId(id);
    setFilter(filter);
  };

  console.log("username", username);
  const handleClosePopup = () => {
    setOpenPopup(false);
    setFetchedData([]);
  };
  const navigate = useNavigate();

  const totalNotStarted = originalData.reduce((total, item) => {
    console.log("item", item.not_started);
    return total + item.not_started;
  }, 0);

  const totalCompleted = originalData.reduce((total, item) => {
    return total + item.completed;
  }, 0);

  const totalOverdue = originalData.reduce((total, item) => {
    return total + item.over_due;
  }, 0);

  const allTaskList = [
    ...originalData,
    {
      task_subject: "Total",
      not_started: totalNotStarted,
      completed: totalCompleted,
      over_due: totalOverdue,
    },
  ];

  const columns = [
    {
      field: "task_subject",
      headerName: "Tasks",
      flex: 1,
      headerClassName: "header-cell",
      valueGetter: (params) => params.value,
      renderCell: (params) => (
        <Typography
          variant={params.row?.task_subject === "Total" ? "h4" : "h6"}
        >
          {params.row?.task_subject}
        </Typography>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "not_started",
      headerName: "Not Started",
      flex: 1,
      headerClassName: "header-cell",
      valueGetter: (params) => params.value,
      renderCell: (params) => (
        <Typography
          onClick={() => {
            if (params.row?.task_subject !== "Total") {
              handleOpenPopup(params.row?.id_of_task_type, "notstarted");
            }
          }}
          style={{
            cursor: "pointer",
            fontWeight: params.row?.task_subject === "Total" ? "bold" : 600,
            color: params.row?.task_subject === "Total" ? "Black" : "blue",
          }}
        >
          {params.row?.not_started}
        </Typography>
      ),
      headerAlign: "center",
      align: "center",
    },

    {
      field: "completed",
      headerName: "Completed",
      flex: 1,
      headerClassName: "header-cell",
      valueGetter: (params) => params.value,
      renderCell: (params) => (
        <div
          onClick={() => {
            if (params.row?.task_subject !== "Total") {
              handleOpenPopup(params.row?.id_of_task_type, "completed");
            }
          }}
          style={{
            cursor: "pointer",
            fontWeight: params.row?.task_subject === "Total" ? "bold" : 600,
            color: params.row?.task_subject === "Total" ? "Black" : "blue",
          }}
        >
          {params.row?.completed}
        </div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "over_due",
      headerName: "Overdue",
      flex: 1,
      headerClassName: "header-cell",
      valueGetter: (params) => params.value,
      renderCell: (params) => (
        <div
          onClick={() => {
            if (params.row?.task_subject !== "Total") {
              handleOpenPopup(params.row?.id_of_task_type, "overdue");
            }
          }}
          style={{
            cursor: "pointer",
            fontWeight: params.row?.task_subject === "Total" ? "bold" : 600,
            color: params.row?.task_subject === "Total" ? "Black" : "blue",
          }}
        >
          {params.row?.over_due}
        </div>
      ),
      headerAlign: "center",
      align: "center",
    },
  ];

  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}route/getalluser`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setUserlist(sortedData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const allUserList =[{first_name:"Select All"} , ...userlist]
  const handleUserchange = (event, value) => {
    if (value.some((option) => option.first_name === "Select All")) {
      setUserName(userlist);
    } else {
      setUserName(value);
    }

  
  };

  const handleStartDateChange = (e) => {
    setFromDate(e.target.value);
  };
  const handleToDateChange = (e) => {
    setToDate(e.target.value);
  };

  const handleFilterChange = (event) => {
    setFilterType(event.target.value);
  };

  console.log("data1", todayTaskReportData);
  console.log("data1", taskReportData);
  const fetchTodayTaskReport = async () => {
    setIsLoading(true);
    // Simulate API fetch or set your actual data

    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    const apiUrl = `${API_ENDPOINT}route/todaytask`;

    try {
      // const response = await fetch(apiUrl);
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify({
          user_id: parseInt(userId),
          filter: filterType || null,
          to_date: fromDate || null,
          from_date: toDate || null,
          filter_for: username.map((i)=>i.id) || [],
        }),
      });

      if (response.ok) {
        const data = await response.json();

        console.log(data);

        if (filterType === "today" && username === null) {
          setTodayTaskReportData(data);
        }

        setTaskReportData(data);
        setOriginalData(data);
        setfilteredData(data);
        setIsLoading(false);
      } else if (response.status === 404) {
        navigate("/page404");
      } else if (response.status === 401) {
        navigate("/page401");
      } else if (response.status === 403) {
        navigate("/page403");
      } else if (response.status === 440) {
        navigate("/page440");
      } else {
        navigate("/page500");
      }
    } catch (error) {
      navigate("/page500");
    }
  };

  useEffect(() => {
    fetchTodayTaskReport();
  }, []);

  const handleApplyFilter = () => {
    fetchTodayTaskReport();
    setGridKey((prev) => prev + 1);
  };

  const handleResetFilter = () => {
    setUserName([]);
    setFromDate("");
    setToDate("");
    setFilterType("today");

    setOriginalData(todayTaskReportData);

    setNameFilter("");
  };

  const handleChangeNmae = (e) => {
    const value = e.target.value;
    setNameFilter(value);

    // Filter data immediately
    let filteredData = filterData.filter((task) =>
      task.task_subject.toLowerCase().includes(value.toLowerCase())
    );
    setOriginalData(filteredData);
    setGridKey((prev) => prev + 1);
  };

  useEffect(() => {
    if (selectedrowId !== null && filter !== null) {
      const requestData = {
        user_id: parseInt(userId),
        type_of_task: selectedrowId,
        filter: filterType,
        to_date: fromDate || null,
        from_date: toDate || null,
        filter_for: username.map((i)=>i.id) || [],
        task_status: filter,
      };
      setTaskLoading(true);
      // Fetch data using selectedRowId and set it in the state
      console.log(selectedrowId);
      console.log(requestData);
      fetch(`${API_ENDPOINT}route/specifictask`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      })
        .then((response) => {
          if (response.status === 200) {
            // setTaskLoading(false);
            return response.json();
          } else if (response.status === 403) {
            setTaskLoading(false);
            throw new Error(
              "Couldn't find any slot for this test type, try next day!!"
            );
          } else if (response.status === 404) {
            setTaskLoading(false);
            throw new Error("Cannot return data, 404");
          } else {
            setTaskLoading(false);
            throw new Error("Unexpected error occurred");
          }
        })
        .then((data) => {
          setFetchedData(data);

          setTaskLoading(false);
          setSelectedRowId(null);
          setFilter(null);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setTaskLoading(false);
          setFetchedData([]);
        });
    }
  }, [selectedrowId, filter]);

  return (
    <>
      <Backdrop open={isLoading} style={{ zIndex: 9999 }}>
        <Typography variant="h4" color="error" fontWeight={800} marginRight={2}>
          Fetching
        </Typography>
        <CircularProgress color="primary" />
      </Backdrop>
      <Grid container spacing={2}>
          <Grid item xs={12} lg={2} sm={4} md={3}>
                         <HeadingCard>
                           <Typography variant="h3" textAlign="center">
                             {" "}
                           Task Report
                           </Typography>
                         </HeadingCard></Grid>
       

        <Grid item xs={12} lg={12} md={12} sm={12}>
          <MainCard>
            <Grid container spacing={2}>
              <Grid item xs={12} lg={12} md={12} sm={12}>
                <Typography variant="h4">All Users Task</Typography>
              </Grid>
              {(userRole === "center_admin" || userRole === "data_entry") && (
                <Grid item xs={12} lg={3} md={6} sm={6}>
                  <Typography variant="h6">Select Users</Typography>

                  <CustomAutocompleteComp
                    value={username}
                    multiple
                    onChange={handleUserchange}
                    options={allUserList}
                    getOptionLabel={(option) =>
                      `${option.first_name ? option.first_name : ""} ${
                        option.last_name ? option.last_name : ""
                      }`
                    }
                    tooltipContent={(option) =>
                      `${option.first_name ? option.first_name : ""} ${
                        option.last_name ? option.last_name : ""
                      }`
                    }
                  />
                </Grid>
              )}
              <Grid item xs={12} lg={2} md={3} sm={3}>
                <Typography variant="h6">Select For</Typography>
                <Select
                  value={filterType}
                  onChange={handleFilterChange}
                  fullWidth
                  style={{ borderRadius: "10px" }}
                  size="medium"
                >
                  <MenuItem value="today">Today</MenuItem>
                  <MenuItem value="1week">Last 7 Days</MenuItem>
                  <MenuItem value="1month">Last 30 Days</MenuItem>
                  <MenuItem value="custom">Custom</MenuItem>
                </Select>
              </Grid>

              {filterType === "custom" && (
                <>
                  <Grid item xs={12} lg={2} md={3} sm={3}>
                    <Typography variant="h6"> Due Date From</Typography>
                    <CustomTextFieldComp
                      value={fromDate}
                      onChange={handleStartDateChange}
                      fullWidth
                      type="date"
                      size="normal"
                      InputProps={{ style: { borderRadius: "10px" } }}
                    />
                  </Grid>
                  <Grid item xs={12} lg={2} md={3} sm={3}>
                    <Typography variant="h6"> Due Date To</Typography>
                    <CustomTextFieldComp
                      value={toDate}
                      onChange={handleToDateChange}
                      fullWidth
                      type="date"
                      size="normal"
                      InputProps={{ style: { borderRadius: "10px" } }}
                    />
                  </Grid>
                </>
              )}

              <Grid item xs={12} md={12} lg={3} sm={12}>
                <Typography sx={{ fontWeight: 600, visibility: "hidden" }}>
                  for spacing
                </Typography>
                <Grid container gap={2} ml={1}>
                  <SearchButton label="Search" onClick={handleApplyFilter}   showIcon={true}/>

                  <ResetButtonComp label="Clear" onClick={handleResetFilter} />
                </Grid>
              </Grid>

              <Grid
                item
                xs={12}
                lg={12}
                md={12}
                sm={12}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
                mt={2}
              >
                <SearchTextFieldComp
                  value={namefilter}
                  onChange={handleChangeNmae}
                />
              </Grid>

              <Grid item xs={12} lg={12} md={12} sm={12}>
                <DataGrid
                  key={gridKey}
                  rows={allTaskList}
                  columns={columns}
                  autoHeight
                  getRowId={() => Math.floor(Math.random() * 100000000)}
                  slots={{
                    noRowsOverlay: () => <CustomNoRowsOverlay message="No Data Available" />,
                  }}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 50,
                      },
                    },
                  }}
                  pageSizeOptions={[25, 50, 100]}
                />
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
      </Grid>

      <CustomPopup
        open={openPopup}
        onClose={handleClosePopup}
        component={
          <SpecificTaskTable
            onClose={handleClosePopup}
            fetchedData={fetchedData}
            taskloading={taskloading}
          />
        }
        title="My Task"
        showDivider="true"
        maxWidth="lg"
      />
    </>
  );
}
